import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import cx from 'classnames';

import './Paginate.scss';

class Paginate extends PureComponent {
  static propTypes = {
    blockName: PropTypes.string,
    className: PropTypes.string,
    pageCount: PropTypes.number.isRequired,
    forcePage: PropTypes.number,
    onPageChange: PropTypes.func.isRequired,
    pagesBeforeBreak: PropTypes.number,
    marginPagesDisplayed: PropTypes.number,
    pageRangeDisplayed: PropTypes.number,
  };

  static defaultProps = {
    blockName: 'nx-paginate',
    pagesBeforeBreak: 4,
    marginPagesDisplayed: 1,
    pageRangeDisplayed: 2,
  };

  getBaseArrowClassName = () => `${this.props.blockName}__navigate`;

  getHiddenClassName = () => `${this.props.blockName}__hidden`;

  getPreviousClassName = () => {
    const { forcePage } = this.props;
    let additionalClassNames = '';

    if (forcePage === 0 || !this.isBreakLabelShown()) {
      additionalClassNames += this.getHiddenClassName();
    }

    return `${this.getBaseArrowClassName()} ${additionalClassNames}`;
  };

  getNextClassName = () => {
    const { forcePage, pageCount } = this.props;
    let additionalClassNames = '';

    if (forcePage === pageCount - 1 || !this.isBreakLabelShown()) {
      additionalClassNames += this.getHiddenClassName();
    }

    return `${this.getBaseArrowClassName()} ${additionalClassNames}`;
  };

  isBreakLabelShown = () => this.props.pageCount >= this.props.pagesBeforeBreak;

  render() {
    const {
      blockName,
      pageCount,
      onPageChange,
      forcePage,
      className,
      marginPagesDisplayed,
      pageRangeDisplayed,
    } = this.props;

    if (!pageCount) return null;

    const previousLabel = (
      <i title="Previous page" className={`${blockName}__arrow icon-custom-page-prev`} />
    );

    const nextLabel = (
      <i title="Next page" className={`${blockName}__arrow icon-custom-page-next`} />
    );

    const breakLabel =
      marginPagesDisplayed === 0 && pageRangeDisplayed === 0 ? (
        ''
      ) : (
        <i className={`${blockName}__break icon-custom-options`} />
      );

    return (
      <ReactPaginate
        forcePage={forcePage}
        containerClassName={cx(blockName, className)}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        breakLabel={breakLabel}
        breakClassName={`${blockName}__break`}
        pageCount={pageCount}
        previousLinkClassName={this.getPreviousClassName()}
        nextLinkClassName={this.getNextClassName()}
        pageClassName={`${blockName}__page`}
        pageLinkClassName={`${blockName}__link`}
        marginPagesDisplayed={marginPagesDisplayed}
        pageRangeDisplayed={pageRangeDisplayed}
        onPageChange={onPageChange}
        activeClassName={`${blockName}__page--active`}
      />
    );
  }
}

export default Paginate;